import React from "react";
import { routes } from "./constants/routes";
import {
  createBrowserRouter
} from "react-router-dom";
import { RouterProvider, Navigate  } from 'react-router-dom/dist'
import Home from "./Components/Home/Home";
import { MuiThemeProvider } from '@material-ui/core/styles'
import { CssBaseline } from '@material-ui/core'
import theme from './theme'
import OilFilter from "./Components/Filters/OilFilter";
import AirFilter from "./Components/Filters/AirFilter";
import FuelFilter from "./Components/Filters/FuelFilter";
import Catalog from "./Components/Catalog/Catalog";
import AboutUs from "./Components/Home/AboutUs";
import GpAdmin from "./Components/Admin/GpAdmin";
import Import from "./Components/Admin/Import"
import FilterLookup from "./Components/Home/FilterLookup";
import Brand from "./Components/Admin/Brand";
import Appstart from "./AppStart";
import Quality from "./Components/Quality/Quality";
import Contact from "./Components/Contact/Contact";
import PackagingSolutions from "./Components/Products/PackagingSolutions";
import AddProducts from "./Components/Admin/AddProducts";
import EditProducts from "./Components/Admin/EditProducts";
import Blogs from "./Components/Blogs/allBlogs";
import Blog1 from "./Components/Blogs/firstBlog";
import AddUsers from "./Components/Admin/UserComponents/AddUsers";
import ManageUsers from "./Components/Admin/UserComponents/ManageUsers";
import ImportUpcAndCbm from "./Components/Admin/UpcCbmAndScanComponents/UpcAndCbm";
import ScanComponent from "./Components/Admin/UpcCbmAndScanComponents/Scan";
import {InwardScan} from "./Components/Admin/UpcCbmAndScanComponents/InwardScan";
import ContainerDetails from "./Components/Admin/ContainerDetailsComponent/ContainerDetails";
import ContainerParts from "./Components/Admin/ContainerDetailsComponent/ContainerParts";
import { ShipToLoc } from "./Components/Admin/ShipToLoc";
import { Dashboard } from "./Components/Admin/Dashboard";
import { ResetPassword } from "./Components/Admin/ResetPassword";
import { UpdatedInwardScan } from "./Components/Admin/UpcCbmAndScanComponents/UpdatedInwardScan";
// const Routess=()=>{
// return(
// <Theme>
// <Router>
//     <Routes>
//     <Route path={routes.HOME} element={<Home/>}/>
//     <Route path="*" element={<Home/>}/>
//     <Route path={routes.OILFILTER} element={<OilFilter/>}/>
//     <Route path={routes.AIRFILTER} element={<AirFilter/>}/>
//     <Route path={routes.FUELFILTER} element={<FuelFilter/>}/>
//     <Route path={routes.CATALOG} element={<Catalog/>}/>
//     <Route path={routes.ABOUTUS} element={<AboutUs/>}/>
//     {/* <Route path={routes.GPADMIN} element={<GpAdmin/>}/> */}
//     <Route path={routes.FILTERLOOKUP} element={<FilterLookup/>}/>
//     {/* <Route path={routes.BRANDTYPE} element={<Brand />} /> */}
//     {/* <Route path={routes.IMPORT} element={<Import/>}/> */}
//     </Routes>
// </Router>
// </Theme>
// )
// }
// export default Routess;
// const AppRoutes = ({ initialRoute }) => {
//   const appRoutes = createBrowserRouter([
//     {
//       path: "/",
//       element: <Navigate to={initialRoute} replace />, // redirect on first load
//     },
//     {
//       path: routes.APPSTART,
//       element: <Appstart />,
//       children: [
//         { path: routes.GPADMIN, element: <GpAdmin /> },
//         { path: routes.RESETPASS, element: <ResetPassword /> },
//         { path: routes.DASHBOARD, element: <Dashboard /> },
//         { path: routes.BRANDTYPE, element: <Brand /> },
//         { path: routes.IMPORT, element: <Import /> },
//         { path: routes.SHIP_TO_LOC, element: <ShipToLoc /> },
//         { path: routes.ADD_PRODUCTS, element: <AddProducts /> },
//         { path: routes.EDIT_PRODUCTS, element: <EditProducts /> },
//         { path: routes.ADD_USERS, element: <AddUsers /> },
//         { path: routes.MANAGE_USERS, element: <ManageUsers /> },
//         { path: routes.UPC_CBM, element: <ImportUpcAndCbm /> },
//         { path: routes.OUTWARD_SCAN, element: <ScanComponent /> },
//         { path: routes.INWARD_SCAN, element: <InwardScan /> },
//         { path: routes.CONTAINER_DETAILS, element: <ContainerDetails /> },
//         { path: routes.CONTAINER_PARTS, element: <ContainerParts /> },
//       ],
//     },
//     { path: routes.HOME, element: <Navigate to={initialRoute} replace /> },
//     { path: routes.ABOUTUS, element: <AboutUs /> },
//     { path: routes.AIRFILTER, element: <AirFilter /> },
//     { path: routes.FUELFILTER, element: <FuelFilter /> },
//     { path: routes.OILFILTER, element: <OilFilter /> },
//     { path: routes.CATALOG, element: <Catalog /> },
//     { path: routes.QUALITY, element: <Quality /> },
//     { path: routes.FILTERLOOKUP, element: <FilterLookup /> },
//     { path: routes.CONTACT, element: <Contact /> },
//     { path: routes.BLOGS, element: <Blogs /> },
//     { path: routes.BLOG1, element: <Blog1 /> },
//     { path: routes.PACKAGINGSOLUTIONS, element: <PackagingSolutions /> },
//     { path: "*", element: <Navigate to={initialRoute} replace /> },
//   ]);

//   return (
//     <MuiThemeProvider theme={theme}>
//       <CssBaseline />
//       <RouterProvider router={appRoutes} />
//     </MuiThemeProvider>
//   );
// };

// export default AppRoutes;

const appRoutes = createBrowserRouter([
  {
    path: routes.APPSTART,
    element: <Appstart />,
    children: [
      {
        path: routes.GPADMIN,
        element: <GpAdmin />
      },
      {
        path: routes.RESETPASS,
        element: <ResetPassword />
      },
      {
        path: routes.DASHBOARD,
        element: <Dashboard />
      },
      {
        path: routes.BRANDTYPE,
        element: <Brand />
      },
      {
        path: routes.IMPORT,
        element: <Import />
      },
      {
        path: routes.SHIP_TO_LOC,
        element: <ShipToLoc />
      },
      {
        path: routes.ADD_PRODUCTS,
        element: <AddProducts />
      },
      {
        path: routes.EDIT_PRODUCTS,
        element: <EditProducts />
      },
      {
        path: routes.ADD_USERS,
        element: <AddUsers />
      },
      {
        path: routes.MANAGE_USERS,
        element: <ManageUsers />
      },
      {
        path: routes.UPC_CBM,
        element: <ImportUpcAndCbm />
      },
      {
        path: routes.OUTWARD_SCAN,
        element: <ScanComponent />
      },
      {
        path:routes.INWARD_SCAN,
        element: <InwardScan />
      },
      {
        path: routes.UPDATE_INWARD_SCAN,
        element: <UpdatedInwardScan />
      },
      {
        path: routes.CONTAINER_DETAILS,
        element: <ContainerDetails />
      },
      {
        path: routes.CONTAINER_PARTS,
        element: <ContainerParts />
      },
    ]
  },
  {
    path: routes.HOME,
    element: <Home />,
  },
  {
    path: routes.ABOUTUS,
    element: <AboutUs />,
  },
  {
    path: routes.AIRFILTER,
    element: <AirFilter />,
  },
  {
    path: routes.FUELFILTER,
    element: <FuelFilter />,
  },
  {
    path: routes.OILFILTER,
    element: <OilFilter />,
  },
  {
    path: routes.CATALOG,
    element: <Catalog />,
  },
  {
    path: routes.QUALITY,
    element: <Quality />,
  },
  {
    path: routes.FILTERLOOKUP,
    element: <FilterLookup />,
  },
  {
    path: routes.CONTACT,
    element: <Contact />,
  },
  {
    path: routes.BLOGS,
    element: <Blogs/>,
  },
  {
    path: routes.BLOG1,
    element: <Blog1/>,
  },
    
  {
    path: routes.PACKAGINGSOLUTIONS,
    element: <PackagingSolutions />,
  },
  {
    path: "*",
    element: <Home />,
  },
])

const Theme = ({ children }) => {
  console.log(children)
  return (
    <MuiThemeProvider theme={theme}>
      {' '}
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  )
}

const AppRoutes = () => {
  return (
    <Theme>
      <RouterProvider router={appRoutes} />
    </Theme>
  )
}
export default AppRoutes;
